<template>
  <div>
    <div class="dashboard-page-title">
      <div class="container-fluid">
        <h1>Add Admin</h1>
      </div>
    </div>

    <div class="container-fluid">
      <div class="dashboard-block">
        <form>
          <div class="panel panel-grey">
            <div class="panel-body">
              <div class="form-horizontal">

                <div class="row">
                  <div class="col-md-12 col-lg-6">
                    <field-input :model="$v.stateFirstName" field-name="First name"/>
                  </div>
                  <div class="col-md-12 col-lg-6">
                    <field-input :model="$v.stateLastName" field-name="Last name"/>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12 col-lg-6">
                    <field-input :model="$v.stateEmail" field-name="Email"/>
                  </div>
                  <div v-if="$showDepartmentField" class="col-md-12 col-lg-6">
                    <department-selection :model="$v.stateDepartment"/>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 col-lg-6">
                    <div class="form-group" :class="$v.stateRole.$error ? 'has-error red-border' : ''">
                      <label class="control-label col-sm-4">
                        * Role
                      </label>
                      <div class="col-sm-8">
                        <selectize
                          class="form-control selectize selectize-single"
                          :class="$v.stateRole.$error ? 'has-error red-border' : ''"
                          name="role"
                          v-model="$v.stateRole.$model"
                          :options="roleOptions"/>
                          <div v-if="$v.stateRole.$error" class="help-block pull-right">Role is required</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel-footer">
              <ladda-button
                class="btn btn-sm btn-primary"
                type="submit"
                :click="handleAddAdminCallback">
                Add Admin
              </ladda-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import {stateMapper} from 'mixins/users'
import {pick} from 'lodash'
import {handleServerErrors} from 'utils/http'
import {notify} from 'utils'
import DepartmentSelection from '../misc/DepartmentSelection'
import {required, requiredIf, email} from 'vuelidate/lib/validators'
import FieldInput from '../misc/FieldInput'
import Selectize from '../ext/codium/CodiumSelectize'

export default {
  mixins: [stateMapper],

  components: {
    Selectize,
    FieldInput,
    DepartmentSelection
  },

  validations: {
    stateFirstName: {
      required
    },
    stateLastName: {
      required
    },
    stateEmail: {
      required,
      email
    },
    stateDepartment: {
      required: requiredIf(function (model) {
        return this.$showDepartmentField
      })
    },
    stateRole: {
      required
    }
  },

  created () {
    this.resetUser()
  },

  computed: {
    roleOptions () {
      const options = [
        { id: 'admin', text: 'Admin' },
        { id: 'restricted-admin', text: 'Restricted Admin' },
        { id: 'reporting-admin', text: 'Reporting Admin' }
      ]
      return options
    }
  },

  methods: {
    ...mapActions('user', ['resetUser']),
    ...mapActions('admin', ['storeAdmin']),

    handleAddAdminCallback () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        notify.error(`Some fields failed validation. Please fix them and try again`)
        return Promise.reject(new Error('Data invalid'))
      }
      const payload = pick(this.user, [
        'first_name',
        'last_name',
        'email',
        'department_id'
      ])
      payload.role = this.user.role

      return this.storeAdmin(payload).then((response) => {
        this.$router.push({name: 'admins.profile.show', params: {id: response.data.id}})
      }).catch((error) => {
        if (error.response && error.response.status === 422) {
          handleServerErrors(error, this.errors)
        } else {
          throw error
        }
      })
    }
  }
}
</script>
